import styled from "@emotion/styled";
import theme from "@vromo/ui/components/theme";


export const Details = styled.div`
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    margin: auto;
    width: 50%;
    text-align:center;
    min-width: 200px;
    border-color: ${theme.success};
    color: ${theme.success};
`